import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import {getTextOrDefault, getImageUrlOrDefault} from 'app/Components/Block/BusinessDashboardBlock/utils/functions';
import {handleClick} from 'app/Components/Block/ArticlePagesBlock/utilities';
import {navigateTo} from 'app/utilities/StringHelpers/StringHelpers';
import Config from 'app/Config';

const IvrCategoryAction = ({action = {}}) => {
  const {actionIconUrl, actionName, actionLinkUrl} = action;

  const actionIconFullUrl = actionIconUrl ? Config.epiBaseUrl + actionIconUrl : '';

  const handleClick = () => {
    if (actionLinkUrl) {
      navigateTo(actionLinkUrl);
    }
  };

  return (
    actionLinkUrl && (
      <div className='ivr-category-action' onClick={handleClick}>
        {actionIconFullUrl && <Image className='action-icon' src={actionIconFullUrl} />}
        {actionName && <span className='action-title'>{actionName}</span>}
      </div>
    )
  );
};

export default IvrCategoryAction;
